var _desc, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEraserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18 18.043",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc-eraserIcon"
  }, " \uC9C0\uC6B0\uAC1C ")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .eraser { fill: #b9b9b9; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.001 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "eraser",
    id: "\\uD328\\uC2A4_4004",
    "data-name": "\\uD328\\uC2A4 4004",
    d: "M17.55,17.17H8.469l9.148-9.148a1.3,1.3,0,0,0,0-1.845L11.826.385a1.314,1.314,0,0,0-1.849,0L1.134,9.227a3.879,3.879,0,0,0,0,5.481L4.2,17.777l.072.059a.45.45,0,0,0,.256.211H17.55a.45.45,0,1,0,0-.9ZM10.616,1.019a.4.4,0,0,1,.571,0l5.791,5.791a.4.4,0,0,1,0,.576l-5.643,5.665L4.95,6.667ZM4.874,17.17a.121.121,0,0,1-.036-.031L1.769,14.074a2.974,2.974,0,0,1,0-4.207L4.334,7.3,10.7,13.669,7.227,17.138a.121.121,0,0,1-.036.031Z",
    transform: "translate(-0.001 -0.004)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserIcon);
export default __webpack_public_path__ + "static/media/EraserIcon.97810a91.svg";
export { ForwardRef as ReactComponent };